import React from "react";
import ProfileImg from "../../assets/images/profile.jpg";
import UserProfileBox from "./UserProfileBox";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";



const ProfileList = (props) => {
  const list = props.list;
  const detail = props.detail;
  var settings = {
    dots: false,
    infinite: false,
    draggable: true,
    // speed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    touchMove: true,
    autoplay: false,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          variableWidth: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1

        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true
        }
      }
    ]

  };
  return (
    <div className="col-lg-10 d-flex flex-wrap mx-auto">
      <div
        className={`wrap_profileList ${list !== undefined && list.length >= 5 && 'max-user-limit'} nav-pills`}
        id="v-pills-tab"
        role="tablist"
        aria-orientation="vertical"
      >
        <Slider {...settings}>
          {list !== undefined && list.map((item) => (
            <>
            <UserProfileBox
              key={item.id}
              userId={item.id}
              studentImg={item.profile_picture}
              studentName={item.name}
              formNumber={item.form_num}
              studentClass={item.class}
              courseCode={item.courseCode}
              activeClass={item.id ===  detail?.id ? 'active':''}
              // courseName={item.course}
              onClick={props.onClick}
            />
            </>
          ))}
        </Slider>


      </div>
      {/* to="/add-profile" */}
      {/* {list !== undefined && list.length !== 5 && <Link
        to="/add-profile"
        state={{detail: detail}}
        className="add-profile d-flex align-items-center flex-wrap justify-content-center text-center box py-2 px-3 mb-3 d-inline"
      >
        <FontAwesomeIcon
          icon={faPlus}
          className="h3 add-profile-btn"
        />{" "}
        <h6 className="w-100">Add Profile</h6>
      </Link>} */}

    </div>
  );
};

export default ProfileList;
